
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import { useEffect } from "react";
import { supabase } from "./utils/supabase";


function App() {
  useEffect(() => {
    // Limpar sessões inválidas ao iniciar o app
    const cleanInvalidSession = async () => {
      try {
        const { error } = await supabase.auth.getSession();
        if (error) {
          // Se houver erro ao obter a sessão, limpar tudo
          await supabase.auth.signOut();
        }
      } catch (err) {
        // Em caso de erro, limpar qualquer sessão corrompida
        await supabase.auth.signOut();
      }
    };

    cleanInvalidSession();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
